import React from 'react';
import { get, isEmpty, map, merge, cloneDeep } from 'lodash';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// React view component to render
import { epostAllergiesAndHealthConditions as EpostAllergiesAndHealthConditionsView } from 'ui/views/widgets/epostAllergiesAndHealthConditions';
import { EpostAllergiesAndHealthConditionsService } from 'services/epostAllergiesAndHealthConditions';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';
import { SERVICE_RESPONSE_STATUS, SIZES, } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { EpostAllergiesAndHealthConditions } from 'ui/containers/EpostAllergiesAndHealthConditions';
 *
 * // render
 * <EpostAllergiesAndHealthConditions propName='propValue'/>
 */
class _EpostAllergiesAndHealthConditions extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

         // check if URL container `step` query parameter.
         const queryParams = queryString.parse( this.props.location.search );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            allergies: {},
            healthConditions: {},
            origin: get( queryParams, 'origin', null )
        };

        // create service instance
        this.epostAllergiesAndHealthConditionsService = new EpostAllergiesAndHealthConditionsService();
        
        // start data fetch
        this.fetchComponentData();

        this.__bind();
    }

    __bind() {
        this.handleNavActions = this.handleNavActions.bind( this );
        this.handleAllergiesUpdate = this.handleAllergiesUpdate.bind( this );
        this.handleHealthConditionsUpdate = this.handleHealthConditionsUpdate.bind( this );
    }

      /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'EpostAllergiesAndHealthConditions.fetchComponentData()' );
;
        // cancel ongoing request
        this.epostAllergiesAndHealthConditionsService.cancel();

        // fetch component data
        const { status, data } = await this.epostAllergiesAndHealthConditionsService.fetchComponentData(  {
            url: this.props.widget.url,
            data: this.props.requestPayload
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                allergies: {
                    ids: map( get( data, 'allergies', [] ), 'id' ),
                    note: '',
                    isAllergiesNotAtVerified: data.isAllergiesNotAtVerified,
                    isNoKnownDrugAllergies: data.isNoKnownDrugAllergies
                },
                healthConditions: {
                    ids: map( get( data, 'healthConditions', [] ), 'id' ),
                    note: '',
                    isHealthConditionsNotAtVerified: data.isHealthConditionsNotAtVerified,
                    isNoKnownHealthConditions: data.isNoKnownHealthConditions
                }
            } );
        }
    }

    /**
     * @desc When allergies selection changes
     */
    handleAllergiesUpdate( { selectedItems, note, isAllergiesNotAtVerified, isNoKnownDrugAllergies } = {} ) {
        log.debug( 'EpostAllergiesAndHealthConditions.handleAllergiesUpdate()' );
        this.setState( {
            allergies: {
                ids: selectedItems,
                note: note,
                isAllergiesNotAtVerified: isAllergiesNotAtVerified,
                isNoKnownDrugAllergies: isNoKnownDrugAllergies,
               
            }
        } );
    }

    /**
     * @desc When health conditions selection changes
     */
    handleHealthConditionsUpdate( { selectedItems, note, isHealthConditionsNotAtVerified, isNoKnownHealthConditions } = {} ) {
        log.debug( 'EpostAllergiesAndHealthConditions.handleHealthConditionsUpdate()' );
        this.setState( {
            healthConditions: {
                ids: selectedItems,
                note: note,
                isHealthConditionsNotAtVerified: isHealthConditionsNotAtVerified,
                isNoKnownHealthConditions: isNoKnownHealthConditions
            }
        } );
    }

    /**
	 * @desc Submit step specific data
	 */
	async submitStepData( action = {} ) {
		log.debug( 'EpostAllergiesAndHealthConditions.submitStepData()' );
		// cancel ongoing request
		this.epostAllergiesAndHealthConditionsService.cancel();

		// show page level preloader
		pageLevelPreloader.show();
        if( ( 'none' ==this.state.allergies.ids && false ===this.state.allergies.isAllergiesNotAtVerified && false ===this.state.allergies.isNoKnownDrugAllergies ) || ( 'none' ==this.state.healthConditions.ids && false ===this.state.healthConditions.isNoKnownHealthConditions ) ) {
            pageLevelPreloader.hide();
            errorOverlay.open( { message: 'Please select any one of above option ' , size: SIZES.SMALL } ) ;
        }else{
                // get status and service data
                const { status, data } = await this.epostAllergiesAndHealthConditionsService.submitStepData( {
                    url: action.url,
                    data: merge( cloneDeep( this.props.requestPayload ), {
                        data: {
                            allergies: this.state.allergies,
                            healthConditions: this.state.healthConditions,
                           
                        }
                    } ),
                } );
            
        
                // hide page level preloader
                pageLevelPreloader.hide();
        
                // check if response status was success
                if ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
                    this.props.moveForward();
                } else {
        
                    // show error dialog
                    if ( !isEmpty( data.description ) ) {
                        errorOverlay.open( { message: data.description, size: SIZES.SMALL } );
                    } else {
                        errorOverlay.open();
                    }
                }
            }
            }
            
            /**
     * handle nav actions
     */
    handleNavActions( { action } ) {
        log.debug( 'EpostAllergiesAndHealthConditions.handleNavActions()' );

        if( 'cancel' === action.name ) {

            if( 'verification' === get( this.state, 'origin', null ) ) {
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.CALL_AUTHORIZATION_FLOW,
                    search: queryString.stringify( {
                        verifyOther: true,
                        step: 2,
                    } ),
                } );
            } else {
                this.props.history.goBack();
            }

            // this.props.history.goBack();
        }

        if( 'next' === action.name ) {
            this.submitStepData( action );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.epostAllergiesAndHealthConditionsService.cancel(); // cancel ongoing requests
    }


    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <EpostAllergiesAndHealthConditionsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onNavActionClick={ this.handleNavActions }
                onAllergiesUpdate={ this.handleAllergiesUpdate }
                onHealthConditionsUpdate={ this.handleHealthConditionsUpdate }
                disableNextAction={ isEmpty( get( this.state, 'allergies.ids' ) ) || isEmpty( get( this.state, 'healthConditions.ids' ) ) }

                // disableNextAction={ false }
            />
        );
    }
}

// set display name
_EpostAllergiesAndHealthConditions.displayName = 'EpostAllergiesAndHealthConditions';

// set default props
_EpostAllergiesAndHealthConditions.defaultProps = {
    requestPayload: {},
};

// prop types
_EpostAllergiesAndHealthConditions.propTypes = {};

export const EpostAllergiesAndHealthConditions = withRouter( _EpostAllergiesAndHealthConditions );

